module.exports = __webpack_public_path__ + "assets/img/useCases.adb33dd6.png";